import { render, staticRenderFns } from "./agentLogin.vue?vue&type=template&id=1931ec1c&scoped=true&"
import script from "./agentLogin.vue?vue&type=script&lang=js&"
export * from "./agentLogin.vue?vue&type=script&lang=js&"
import style0 from "./agentLogin.vue?vue&type=style&index=0&id=1931ec1c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1931ec1c",
  null
  
)

export default component.exports